import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

import { defineComponent, watch, withDefaults, h } from 'vue';
import { Element } from '../../models/component';
import { state as globalState, createState } from '../../store/state-confirm'; /* eslint-disable-line */


export default /*#__PURE__*/_defineComponent({
  __name: 'Confirm',
  props: {
    el: { default: () => ({ component: 'span' }) },
    globalComponent: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { el: Element, globalComponent: boolean };

defineComponent({ name: 'CwConfirm' });



const state = props.globalComponent ? globalState : createState();
const text = state.text ? JSON.parse(JSON.stringify(state.text)) : undefined;

const cwConfirmChild = {
  render() {
    return h(props.el?.component ?? 'span', props.el?.props ?? undefined, text);
  },
};

watch(props, (v, vo) => {
  if (v.globalComponent !== vo.globalComponent) Object.assign(state, v.globalComponent ? globalState : createState());
});

expose({ ...state });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, _mergeProps({ ..._ctx.$props, ..._unref(state).props }, {
    modelValue: _unref(state).display,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).display) = $event)),
    width: "500",
    persistent: ""
  }), {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "cw-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "3",
            "align-self": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-alert-octagon",
                color: _unref(state).color,
                class: _normalizeClass(['cw-icon-dialog-confirm', _unref(state).backgroundColor ?? ''])
              }, null, 8, ["color", "class"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "pa-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "w-100",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h5 font-weight-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(state).title), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { style: `height: 60px;` }, {
                    default: _withCtx(() => [
                      (__props.el?.component === 'span')
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(cwConfirmChild), {
                            key: 0,
                            innerHTML: _unref(state).text
                          }, null, 8, ["innerHTML"]))
                        : (_openBlock(), _createBlock(_resolveDynamicComponent(cwConfirmChild), { key: 1 }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        color: _unref(state).buttonNo?.color,
                        variant: "text",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).onClick(false)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(state).buttonNo?.text), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_v_btn, {
                        color: _unref(state).buttonYes?.color,
                        variant: "text",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).onClick(true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(state).buttonYes?.text), 1)
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["modelValue"]))
}
}

})